import React from "react";
import scale from "@/public/fallbacks/scale.svg";

const SizeChart = ({ sizeChartLink, sizeChartLabel }) => {
  return (
    <div className="variants-sizeChart">
      {sizeChartLink && (
        <a className="variants-sizeChart__link" href={sizeChartLink}>
          {sizeChartLabel}
          <img src={scale} className="variants-sizeChart__icon" alt={sizeChartLabel} />
        </a>
      )}
    </div>
  );
};

export default SizeChart;
